import React from 'react';
import classNames from 'classnames';

const TrackerFilterButton = ({active, children, onClick, value, ...rest}) => (
    <button className={classNames('btn btn-sm', {'btn-primary': active, 'btn-outline-primary': !active})} aria-pressed={active || undefined}
        onClick={() => onClick(value)} // eslint-disable-line react/jsx-no-bind
        {...rest}>{children}</button>
);

export default TrackerFilterButton;
